import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import img1 from '../assets/images/DSC08844.webp';
import img2 from '../assets/images/DSC08951.webp';
import img3 from '../assets/images/DSC08906.webp';
import img4 from '../assets/images/DSC08820.webp';
import img5 from '../assets/images/DSC08729.webp';
import img6 from '../assets/images/DSC08847.webp';

const images = [
    { src: img1, quote: "Every love story is beautiful, but ours is my favorite." },
    { src: img2, quote: "You are my today and all of my tomorrows." },
    { src: img3, quote: "I have found the one whom my soul loves." },
    { src: img4, quote: "Together is a beautiful place to be." },
    { src: img5, quote: "In you, I've found the love of my life and my closest, truest friend." },
    { src: img6, quote: "Forever starts now." }
];

const Gallery = () => {
    return (
        <section className="py-24 px-4 md:px-8 bg-wedding-ivory">
            <div className="max-w-7xl mx-auto">
                <Reveal>
                    <div className="text-center mb-20">
                        <span className="uppercase tracking-[0.2em] text-xs text-wedding-gold font-bold mb-4 block">Captured Moments</span>
                        <h2 className="font-serif text-4xl md:text-6xl text-wedding-charcoal">Our Story in Frames</h2>
                    </div>
                </Reveal>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {images.map((item, index) => (
                        <Reveal key={index} delay={index * 100}>
                            <div className="aspect-[3/4] overflow-hidden group relative shadow-lg hover:shadow-xl transition-shadow duration-500">
                                <img
                                    src={item.src}
                                    alt={`Gallery ${index + 1}`}
                                    className={`w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-105 group-hover:blur-sm ${[0, 2, 4].includes(index) ? 'grayscale' : ''
                                        }`}
                                />
                                <div className="absolute inset-0 bg-wedding-charcoal/0 group-hover:bg-wedding-charcoal/40 transition-all duration-500 flex items-center justify-center p-6">
                                    <p className="text-white text-center font-serif text-lg opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0">
                                        {item.quote}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal>
                    <div className="text-center mt-12">
                        <Link to="/gallery" className="inline-block px-8 py-3 border border-wedding-gold text-wedding-gold hover:bg-wedding-gold hover:text-white transition-all duration-300 font-serif italic">
                            View Full Gallery
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}; export default Gallery;
